import { LocaleEnum } from '@systemeio/ui-frontend'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import useUser from 'shared/hooks/use-user'
import { getLoginUrl } from 'shared/utils/url-utils'
import PublicLanguageSwitcher from '../../public-language-switcher'
import { topMenuItems } from '../constants/top-menu-items'
import NavLink from './nav-link'

const DesktopMenu = () => {
  const router = useRouter()
  const locale = router.locale as LocaleEnum
  const { t } = useTranslation()
  const { user } = useUser()
  return (
    <>
      <div className={'hidden w-full items-center justify-between gap-5 lg:flex'}>
        <div className={'flex w-full flex-wrap items-center justify-center gap-10'}>
          {topMenuItems
            .filter(item => !item.excludeLocales?.includes(locale))
            .map((item, index) => (
              <NavLink key={index} href={item.href}>
                {t(item.title)}
              </NavLink>
            ))}
        </div>
      </div>
      <div className={'hidden basis-1/3 items-center justify-end gap-3 lg:flex'}>
        <div className={'flex items-center gap-x-10 gap-y-3'}>
          <NavLink signInLink noLoco href={user ? '/dashboard' : getLoginUrl(locale)}>
            {user ? t('global.dashboard') : t('public.public_header.sing_in')}
          </NavLink>
          {/*{!user && (*/}
          {/*  <PublicButton fontClassName={'font-mulish'}>*/}
          {/*    {t('public.public_header.get_my_free_account')}*/}
          {/*  </PublicButton>*/}
          {/*)}*/}
        </div>
        <PublicLanguageSwitcher />
      </div>
    </>
  )
}

export default DesktopMenu
